import { create } from "zustand";
import { useIntl } from "react-intl";
import { lensPath, set } from "ramda";
import { useCallback } from "react";


export const useFlashMessageStore = create((setState) => ({
  flashMessage: null,
  setFlashMessage: (message, type = "success", timeout = 5000) => setState({
    flashMessage: {
      message,
      type,
      timeout
    }
  }),
  clearFlashMessage: () => setState(
    set(lensPath(["flashMessage", "message"]), "")
  ),
}))

export const useSetFlashMessageId = () => {
  const intl = useIntl()
  const { setFlashMessage } = useFlashMessageStore();

  return useCallback(
    ({ id, values }, type = "success", timeout = 5000) =>
      setFlashMessage(intl.formatMessage({ id }, values), type, timeout),
    [setFlashMessage, intl]
  );
}

export const useShowErrorFlashMessage = () => {
  const setFlashMessageId = useSetFlashMessageId();

  return useCallback(id => setFlashMessageId({ id }, "error"), [setFlashMessageId]);
}